import type {
  Stage,
  ActionOwner,
  StageRole,
} from "../schemas/validators/stage.lib";

export type { Stage, ActionOwner, StageRole };

export const STAGE = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  VENDOR_RESPONDING: "vendor_responding",
  AWAITING_REVIEW: "awaiting_review",
  CONFIRMING_PICKUP: "confirming_pickup",
  CONFIRMED_AWAITING_PAYMENT: "confirmed_awaiting_payment",
  AWAITING_SCHEDULING: "awaiting_scheduling",
  SCHEDULED: "scheduled",
  IN_TRANSIT: "in_transit",
  DELIVERED: "delivered",
  COMPLETE: "complete",
  CANCELLED: "cancelled",
  REFUNDED: "refunded",
  EXPIRED: "expired",
} as const satisfies Record<string, Stage>;

export const STAGES: readonly Stage[] = Object.values(STAGE);

export const CLOSED_STAGES: ReadonlySet<Stage> = new Set([
  STAGE.COMPLETE,
  STAGE.CANCELLED,
  STAGE.REFUNDED,
  STAGE.EXPIRED,
]);

export const ACTION_OWNER = {
  BUYER: "buyer",
  VENDOR: "vendor",
  ADMIN: "admin",
  SYSTEM: "system",
} as const satisfies Record<string, ActionOwner>;
